/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FileImportPreviewResponseDto } from '../models';
/**
 * AIFileSearchApi - axios parameter creator
 * @export
 */
export const AIFileSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} formId ID of the form to import data into
         * @param {Array<File>} files Array of files to upload for form data extraction (max 10 files)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiFileSearchControllerImportFromFiles: async (formId: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('aiFileSearchControllerImportFromFiles', 'formId', formId)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('aiFileSearchControllerImportFromFiles', 'files', files)
            const localVarPath = `/ai-file-search/{formId}/import-from-files`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AIFileSearchApi - functional programming interface
 * @export
 */
export const AIFileSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AIFileSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} formId ID of the form to import data into
         * @param {Array<File>} files Array of files to upload for form data extraction (max 10 files)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiFileSearchControllerImportFromFiles(formId: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileImportPreviewResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiFileSearchControllerImportFromFiles(formId, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIFileSearchApi.aiFileSearchControllerImportFromFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AIFileSearchApi - factory interface
 * @export
 */
export const AIFileSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AIFileSearchApiFp(configuration)
    return {
        /**
         * 
         * @param {string} formId ID of the form to import data into
         * @param {Array<File>} files Array of files to upload for form data extraction (max 10 files)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiFileSearchControllerImportFromFiles(formId: string, files: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<FileImportPreviewResponseDto> {
            return localVarFp.aiFileSearchControllerImportFromFiles(formId, files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AIFileSearchApi - object-oriented interface
 * @export
 * @class AIFileSearchApi
 * @extends {BaseAPI}
 */
export class AIFileSearchApi extends BaseAPI {
    /**
     * 
     * @param {string} formId ID of the form to import data into
     * @param {Array<File>} files Array of files to upload for form data extraction (max 10 files)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIFileSearchApi
     */
    public aiFileSearchControllerImportFromFiles(formId: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return AIFileSearchApiFp(this.configuration).aiFileSearchControllerImportFromFiles(formId, files, options).then((request) => request(this.axios, this.basePath));
    }
}

